import { TableCell } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { RefreshIcon } from "../../../../shared/icons/RefreshIcon";
import { AppPopover } from "../../../AppPopover";
import { usePopover } from "../../../hooks/use-popover";
import { ActionButton } from "../../VersionAction/ActionButton";
import styles from "../VersionsTableBody/styles.module.css";

interface Props {
  name: string;
  id: string;
  onOk: (id: string) => void;
}

export const VersionActionCell: FC<Props> = ({ name, id, onOk }) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();

  return (
    <TableCell className={styles["action-cell"]}>
      <ActionButton icon={<RefreshIcon />} onClick={handleOpenPopover} />
      <AppPopover
        open={openPopover}
        anchorEl={anchorPopoverEl}
        handleClose={handleClosePopover}
        onOk={() => {
          onOk(id);
          handleClosePopover();
        }}
      >
        {t("versioning.restore_popover")}
        <strong>{name}</strong>?
      </AppPopover>
    </TableCell>
  );
};
